export default "__VITE_ASSET__63c9dc05__"